import React from 'react';
import { MEMBER_ROLE_LABELS } from './constants';

const EditMemberModal = ({
  show,
  onClose,
  member,
  editMemberForm,
  onEditMemberFormChange,
  onSubmit,
  isLoading,
  memberRoles,
  groupName,
  users,
}) => {
  if (!show) return null;

  const memberUser = users?.find((u) => u.id === member?.user_id);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4">
      <div className="w-full max-w-md rounded-lg bg-white">
        <div className="p-6">
          <h3 className="mb-4 text-lg font-medium text-gray-900">
            Edit Member Role in {groupName}
          </h3>

          {memberUser && (
            <div className="mb-4 rounded-md bg-gray-50 p-3">
              <div className="flex items-center">
                <div className="mr-3 flex h-8 w-8 items-center justify-center rounded-full bg-blue-100">
                  <span className="text-sm font-medium text-blue-600">
                    {memberUser.first_name?.[0]}
                    {memberUser.last_name?.[0]}
                  </span>
                </div>
                <div>
                  <div className="text-sm font-medium text-gray-900">
                    {memberUser.first_name} {memberUser.last_name}
                  </div>
                  <div className="text-xs text-gray-500">{memberUser.email}</div>
                </div>
              </div>
            </div>
          )}

          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">Role in Group</label>
              <select
                name="role_in_group"
                value={editMemberForm.role_in_group}
                onChange={onEditMemberFormChange}
                className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              >
                {memberRoles.map((role) => (
                  <option key={role} value={role}>
                    {MEMBER_ROLE_LABELS[role] || role.charAt(0).toUpperCase() + role.slice(1)}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label className="mb-1 block text-sm font-medium text-gray-700">Preferred Side</label>
              <select
                name="preferred_side"
                value={editMemberForm.preferred_side}
                onChange={onEditMemberFormChange}
                className="w-full rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                <option value="none">No Preference</option>
                <option value="port">Port (Left)</option>
                <option value="starboard">Starboard (Right)</option>
              </select>
            </div>

            <div className="flex gap-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="flex-1 rounded bg-gray-200 px-4 py-2 font-semibold text-gray-900 transition-colors hover:bg-gray-300"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="flex-1 rounded bg-blue-500 px-4 py-2 font-semibold text-white transition-colors hover:bg-blue-600 disabled:bg-blue-300"
                disabled={isLoading}
              >
                {isLoading ? 'Updating...' : 'Update Role'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditMemberModal;
